import React, { useState, useRef, useEffect } from "react";
import { Modal, Form, Input, Upload, Row, Col, Button, message } from "antd";
import "./AddClientModal.css";
import { FormInputGroup } from "../../../formInputGroup/FormInputGroup";
import { FormInput } from "../../../formInput/FormInput";
import PhoneNumber from "../../../form/components/Countrycode";
import fileUploadIcon from "../../../../assets/SVGs/Vector.svg";
import { MODULE_API } from "../../../../apis";
import axios from "axios";
import NewLoader from "../../loader/NewLoader";
import defaultProfilePicture from "../../../../assets/images/newdefaultprofilepicture.png";

const AddClientModal = ({
  open,
  onCancel,
  onSave,
  form,
  showLoader,
  setShowLoader,
  formData,
  setFormData,
  readOnly,
  reset,
  setReset,
}) => {
  const { getFieldDecorator, validateFields, resetFields } = form;

  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role") || null);
  const [errors, setErrors] = useState({});

  const fileInputRef = useRef(null);

  useEffect(() => {
    console.log("formD", formData);
  }, [formData]);

  const defaultSetting = {
    dragDrop: [
      {
        id: "budgetExpanse",
      },
      {
        id: "dashboardBudgetSection",
      },
      {
        id: "dashboardSavingSection",
      },
      {
        id: "topMonthlyExpanse",
      },
      {
        id: "goalProgress",
      },
      {
        id: "dashboardGoalCharts",
      },
      {
        id: "dashboardGoalSection",
      },
    ],
    dragCards: [
      {
        id: "budgetExpanse",
      },
      {
        id: "dashboardBudgetSection",
      },
      {
        id: "dashboardSavingSection",
      },
      {
        id: "topMonthlyExpanse",
      },
      {
        id: "goalProgress",
      },
      {
        id: "dashboardGoalCharts",
      },
      {
        id: "dashboardGoalSection",
      },
    ],
    dashboard1DragCards: [
      {
        id: "topMonthlyExpanse",
      },
      {
        id: "goalProgress",
      },
      {
        id: "dashboardGoalCharts",
      },
    ],
    dashboard2DragCards: [
      {
        id: "DashboardCalendar",
      },
    ],
    dashboard3DragCards: [
      {
        id: "topMonthlyExpanse",
      },
      {
        id: "goalProgress",
      },
      {
        id: "dashboardGoalCharts",
      },
    ],
  };

  const handleImageUpload = async (event) => {
    setShowLoader(true);
    const file = event.target.files[0];
    if (!file) return;

    const fileSize = file.size / (1024 * 1000); // in MB
    if (fileSize > 5) {
      console.log("File size should be less than 5MB");
      return;
    }

    const name = file.name;
    const lastDot = name.lastIndexOf(".");
    const ext = name.substring(lastDot + 1);

    try {
      const resdata = await MODULE_API.uploadFile({
        fileExt: ext,
        contentType: file.type,
      });

      await axios.put(resdata.uploadUrl, file, {
        headers: { "Content-type": file.type },
      });
      console.log("res", resdata);
      const uploadedUrl = resdata.uploadUrl.split("?")[0];
      // setFormData((prev) => ({ ...prev, image: uploadedUrl }));
      setFormData({
        ...formData,
        ["image"]: uploadedUrl,
      });
      setShowLoader(false);
    } catch (error) {
      message.error("Image upload failed.");
      setShowLoader(false);
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!formData.username.trim()) {
      newErrors.username = "Username is required";
    } else if (!/^[^\s]{3,}$/.test(formData.username)) {
      newErrors.username =
        "Username must be at least 3 characters and contain no spaces";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }

    if (formData.zipCode && !/^\d{5}(-\d{4})?$/.test(formData.zipCode)) {
      newErrors.zipCode = "Invalid zip code";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) return;
    validateFields((err, values) => {
      if (!err) {
        let role = "dashboard_financial_advisor_client"; // default

        // if (userRole && userRole === "Financial Advisor") {
        //   role = "financial adviser client";
        // } else if (userRole && userRole === "Active Financial Advisor") {
        //   role = "Active financial adviser client";
        // }
        const payload = {
          name: formData.name,
          userName: formData.username,
          email: formData.email,
          phoneNumber: formData.phone,
          zipCode: Number(formData.zipCode),
          roles: [role],
          setting: defaultSetting,
          image: formData.image || null,
        };
        onSave(payload);

        resetFields();
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        setFormData({
          name: "",
          username: "",
          email: "",
          phone: "",
          zipCode: "",
          image: "",
        });
        setErrors({});
      }
    });
  };

  const handleCancel = () => {
    resetFields();
    setFormData({
      name: "",
      username: "",
      email: "",
      phone: "",
      zipCode: "",
      image: "",
    });

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }

    onCancel();
  };

  const renderFormInput = (
    label,
    name,
    type = "text",
    placeholder = "",
    required = false
  ) => (
    <FormInputGroup>
      <label>
        {label}
        {required && !readOnly && <span style={{ color: "red" }}>*</span>}
      </label>
      <FormInput
        id={name}
        type={type}
        placeholder={placeholder || label}
        name={name}
        required={required}
        value={formData && formData[name]}
        onChange={(e) => {
          if (!readOnly) {
            const value = e.target.value;
            if (name === "username" && /\s/.test(value)) return; // prevent spaces
            setFormData({ ...formData, [name]: value });
            setErrors({ ...errors, [name]: "" });
          }
        }}
        readOnly={readOnly}
      />
      {errors[name] && <div className="form-error">{errors[name]}</div>}
    </FormInputGroup>
  );

  return (
    <Modal
      visible={open}
      onCancel={handleCancel}
      footer={null}
      centered
      width={730}
      bodyStyle={{
        padding: "32px",
        borderRadius: "12px",
        border: "1px solid #E0E0E0",
        height: 497,
      }}
    >
      <h2 className="add-client-title" id={readOnly && "add-client-title-mb"}>
        {!readOnly ? "Add Client" : "Client Details"}
      </h2>

      {readOnly && (
        <div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              // marginTop: "2rem",
              marginBottom: "1rem",
            }}
          >
            <input
              type="file"
              id="image"
              name="image"
              // onChange={handleImageUpload}
              accept="image/*"
              style={{ display: "none" }}
            />
            <label htmlFor="image" style={{ cursor: "pointer" }}>
              {/* <img
                    width={128}
                    height={128}
                    style={{
                      borderRadius: "50%",
                      border: "2px solid #ED2590",
                      padding: "4px",
                    }}
                    src={
                      (localStorage.getItem("profile") &&
                        localStorage.getItem("profile")) ||
                      defaultProfilePicture
                    }
                    alt="defaultProfilePicture"
                  /> */}
              <div
                style={{
                  width: "64px",
                  minHeight: "64px",
                  borderRadius: "50%",
                  border: "2px solid #ED2590",
                  padding: "4px",
                  backgroundImage: `url('${
                    (formData && formData.image) || defaultProfilePicture
                  }')`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              ></div>
            </label>
            {/* <span
                  style={{
                    fontWeight: "bold",
                    marginTop: "2rem",
                    color: "black",
                  }}
                >
                  {localStorage.getItem("User") ? (
                    localStorage.getItem("User")
                  ) : (
                    <React.Fragment></React.Fragment>
                  )}
                </span> */}
            {/* <span style={{ marginTop: "8px" }}>Project Manager</span> */}
          </div>
        </div>
      )}

      <div className="relative-loader-container">
        <Form layout="vertical" onSubmit={handleSubmit}>
          <div>
            <div className="field-container">
              {renderFormInput("Name", "name", "text", "Name", true)}
              {renderFormInput(
                "Username",
                "username",
                "text",
                "Username",
                true
              )}
            </div>

            <div className="field-container">
              {renderFormInput(
                "Work Email Address",
                "email",
                "email",
                "Email Address",
                true
              )}
              <FormInputGroup>
                <label>
                  Phone Number
                  {!readOnly && <span style={{ color: "red" }}>*</span>}
                </label>
                <PhoneNumber
                  id="phone"
                  name="phone"
                  onKeyPress={() => {}}
                  value={(formData && formData.phone) || ""}
                  // onChange={(value) =>
                  //   setFormData({ ...formData, phone: value.target.value })
                  // }
                  onChange={(value) => {
                    if (!readOnly)
                      setFormData({ ...formData, phone: value.target.value });
                  }}
                  disabled={readOnly}
                  size="large"
                  placeholder="Phone Number"
                  reset={reset}
                  setReset={setReset}
                />
              </FormInputGroup>
            </div>

            <div className="field-container">
              {renderFormInput("Zip Code", "zipCode")}
              {!readOnly && (
                <FormInputGroup>
                  <label>Upload Profile Picture</label>
                  <div className="file-upload-field-wrapper">
                    <label
                      htmlFor="profilePicture"
                      className="upload-btn"
                      style={{
                        cursor: "pointer",
                        width: "92%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: "0px",
                      }}
                    >
                      <input
                        type="file"
                        ref={fileInputRef}
                        // style={{ display: "none" }}
                        id="profilePicture"
                        name="profilePicture"
                        accept="image/*"
                        onChange={(e) => {
                          console.log(e.target.files[0]);
                          handleImageUpload(e);
                        }}
                      />
                      <img src={fileUploadIcon} alt="Upload" />
                    </label>
                  </div>
                </FormInputGroup>
              )}
            </div>
          </div>

          {!readOnly && (
            <div className="field-container">
              <Button
                onClick={handleCancel}
                className="cancel-btn"
                style={{
                  width: 327,
                  height: 46,
                  borderRadius: 8,
                  border: "1px solid rgba(42, 61, 163, 1)",
                  background: "transparent",
                  color: "rgba(42, 61, 163, 1)",
                }}
              >
                Cancel
              </Button>

              <Button
                type="primary"
                htmlType="submit"
                disabled={showLoader}
                id="add-client-submit-button"
                style={{
                  width: 327,
                  height: 46,
                  borderRadius: 8,
                  background: "rgba(42, 61, 163, 1)",
                  border: "1px solid rgba(42, 61, 163, 1)",
                  opacity: showLoader ? 0.6 : 1, // Dim when loading
                  color: "#FFF",
                  cursor: showLoader ? "not-allowed" : "pointer",
                }}
              >
                Save
              </Button>
            </div>
          )}
        </Form>
        <NewLoader
          style={{ zIndex: "99999999" }}
          isLoading={showLoader}
        ></NewLoader>
      </div>
    </Modal>
  );
};

export default Form.create()(AddClientModal);
